<template>
  <div class="filters">
    <ArtworksSortButtons />
    <VueSlideToggle
      id="vueSlideToggle"
      tag="div"
      class="filters__modal"
      :class="{ removeShadow: !showFilters }"
      :open="showFilters"
      :duration="250"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="filters__modal-content">
            <div class="filters__close">
              <button
                @click="showFilters = false"
                type="button"
                class="btn btn__default"
                :title="I18n.t('filters.close_title')"
              >
                <span class="icon icon-close-big"/>
              </button>
            </div>
            <div class="row no-gutters text-left">
              <AuctionHouseFilterColumn />
              <PriceFilterColumn />
              <DateFilterColumn />
              <StateFilterColumn />
              <CategoryFilterColumn />
            </div>
            <div v-if="anyArtworksFilterActive" class="row no-gutters filters__modal-footer">
              <div class="col">
                <button @click="clearFilters()" type="button"
                        class="btn-link filters__remove-all change-margins">
                  <span class="icon icon-close-big"></span>
                  {{ I18n.t("filters.clear_filters") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </VueSlideToggle>
    <transition name="filters-button">
      <div v-if="!showFilters" class="filters__summary">
        <div class="row align-items-start">
          <div class="col-lg-2 mb-md-2 filters__actions d-flex justify-content-between justify-content-sm-start flex-wrap">
            <button @click="showFilters = true"
                    type="button"
                    class="btn btn__default filters__btn">
              <span class="icon icon-filter"></span>
              {{ I18n.t("filters.label") }}
            </button>
          </div>
          <div class="col-lg-10 mt-3 mt-md-0">
            <ActiveFiltersList />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { VueSlideToggle } from 'vue-slide-toggle';
  import { mapGetters, mapActions } from 'vuex';
  import AuctionHouseFilterColumn from './auction_house_filter_column';
  import ArtworksSortButtons from './artworks_sort_buttons';
  import PriceFilterColumn from './price_filter_column';
  import DateFilterColumn from './date_filter_column';
  import CategoryFilterColumn from './category_filter_column';
  import StateFilterColumn from './state_filter_column';
  import ActiveFiltersList from './active_filters_buttons/list';

  export default {
    name: 'ArtworksFiltersPanel',
    components: {
      AuctionHouseFilterColumn,
      PriceFilterColumn,
      DateFilterColumn,
      CategoryFilterColumn,
      StateFilterColumn,
      VueSlideToggle,
      ActiveFiltersList,
      ArtworksSortButtons,
    },
    data() {
      return {
        showFilters: false,
      };
    },
    computed: {
      ...mapGetters(['anyArtworksFilterActive']),
    },
    methods: {
      ...mapActions(['getArtworksWhenFiltersAreCleared']),
      clearFilters() {
        this.getArtworksWhenFiltersAreCleared();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/artworks_filters_panel.vue?e2571620